import Controller from "./cities.controller";
import template from "./cities.html";

const cities = {
  template,
  controller: Controller,
};

export default cities;



// WEBPACK FOOTER //
// ./src/pages/cities/cities.component.js